module.exports = __webpack_public_path__ + "img/04_no.09fb0050.svg";